import i18next from "i18next";
import { FaEye } from "react-icons/fa";

export const CIRCOLANTE_COLUMNS = ({ onSelectItem } = { onSelectItem: (item: any) => { } }) => ([
  {
    accessor: 'contratto_id',
    id: 'contratto_id',
    Header: i18next.t('contratto_id'),
  },
  {
    accessor: 'rental',
    id: 'rental',
    Header: i18next.t('rental'),
  },
  {
    accessor: 'targa',
    id: 'circolante_targa',
    Header: i18next.t('circolante_targa'),
  },
  {
    accessor: 'marca',
    id: 'circolante_marca',
    Header: i18next.t('circolante_marca'),
  },
  {
    accessor: 'modello',
    id: 'circolante_modello',
    Header: i18next.t('circolante_modello'),
  },
  {
    accessor: 'allestimento',
    id: 'allestimento',
    Header: i18next.t('allestimento'),
  },
  {
    accessor: 'canone_totale',
    id: 'circolante_canone_totale',
    Header: i18next.t('circolante_canone_totale'),
  },
  {
    accessor: 'inizio_contratto',
    id: 'inizio_contratto',
    Header: i18next.t('inizio_contratto'),
  },
  {
    accessor: 'fine_contratto',
    id: 'circolante_fine_contratto',
    Header: i18next.t('circolante_fine_contratto'),
  },
  {
    accessor: 'km_contratto',
    id: 'circolante_km_contratto',
    Header: i18next.t('circolante_km_contratto'),
  },
  {
    accessor: 'km_ultimo_rilevamento',
    id: 'circolante_km_ultimo_rilevamento',
    Header: i18next.t('circolante_km_ultimo_rilevamento'),
  },
  {
    accessor: 'data_ultimo_rilevamento',
    id: 'circolante_data_ultimo_rilevamento',
    Header: i18next.t('circolante_data_ultimo_rilevamento'),
  },
  {
    accessor: 'actions',
    id: 'actions',
    Header: '',
    disableSortBy: true,
    headerClassName: 'column-sticky',
    className: 'column-sticky',
    width: 60,
    Cell: (data: any) => (
      <div
        className="btn"
        onClick={() => {
          onSelectItem?.(data.row.original)
        }}
      >
        <FaEye style={{ width: '1.2rem', height: '1.2rem' }} />
      </div>
    ),
  },
]);

export const ORDINATO_COLUMNS = ({ onSelectItem } = { onSelectItem: (item: any) => { } }) => ([
  {
    accessor: 'contratto_id',
    id: 'contratto_id',
    Header: i18next.t('contratto_id'),
  },
  {
    accessor: 'rental',
    id: 'rental',
    Header: i18next.t('rental'),
  },
  {
    accessor: 'targa',
    id: 'ordinato_targa',
    Header: i18next.t('ordinato_targa'),
  },
  {
    accessor: 'marca',
    id: 'ordinato_marca',
    Header: i18next.t('ordinato_marca'),
  },
  {
    accessor: 'modello',
    id: 'ordinato_modello',
    Header: i18next.t('ordinato_modello'),
  },
  {
    accessor: 'allestimento',
    id: 'allestimento',
    Header: i18next.t('allestimento'),
  },
  {
    accessor: 'telaio',
    id: 'ordinato_telaio',
    Header: i18next.t('ordinato_telaio'),
  },
  {
    accessor: 'data_immatricolazione',
    id: 'ordinato_data_immatricolazione',
    Header: i18next.t('ordinato_data_immatricolazione'),
  },
  {
    accessor: 'data_consegna',
    id: 'data_consegna',
    Header: i18next.t('data_prevista_consegna'),
  },
  {
    accessor: 'stato',
    id: 'ordinato_stato',
    Header: i18next.t('ordinato_stato'),
  },
  {
    accessor: 'actions',
    id: 'actions',
    Header: '',
    disableSortBy: true,
    headerClassName: 'column-sticky',
    className: 'column-sticky',
    width: 60,
    Cell: (data: any) => (
      <div
        className="btn"
        onClick={() => {
          onSelectItem?.(data.row.original)
        }}
      >
        <FaEye style={{ width: '1.2rem', height: '1.2rem' }} />
      </div>
    ),
  },
]);
